export default function() {
    return {
        tlosPrice: 0.0,
        gasPrice: 0.0,
        latestBlock : 0,
    };
}
